<template>
    <div class="row" :class="{masque : this.display===true}">
      <p class="select_title">{{ this.description }}</p>
        <div>
          <input class="input" :type="datatype" @change="change" @input="change" v-model="Content" :disabled="readonly" :placeholder="placeholder"/>
        </div>
    </div>    
</template>

<script>
export default {
props:{
    value:{
      required:false
    },
    readonly:{
      default:false
    },
    datatype:{
      type:String,
    },
    placeholder:{
      type:String
    },
    display:{
      type:Boolean,
      default:false
    },
    description:{
      type:String
    }
},
data(){
  return {
    content: this.value
  }
},
computed:{
Content:{
  get(){
    return this.content
  },
  set(Content){
        this.content=Content
  }
}
},
methods:{
  change(){
    this.$emit('input', this.content)
    this.$emit('change', this.content)
  },
},

}
</script>

<style scoped lang="scss">
  .row {
    width: 100%;
    margin:8px;
    .select_title{
      margin-bottom: 10px;
      color: #22ABC5;
      font-size: 15px;
      font-family: Metropolis;
    }
    div{
      margin-left: 0%;
      width: 94%;
      .input {
        color: #22abc5;
        background-color: white;
        padding: 12px;
        border-radius: 5px;
        width: 94%;
        border: 1px solid #22abc500;
        margin-top: 0px;
        font-family: Metropolis;
        &:focus {
          outline: 0;
        }
        &::placeholder {
          color: #b5bcbd;
        }
      } 
    }
    
}
.masque{
  display: none;
}
</style>